import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";

export function useChampionshipData() {
  const preloaded = typeof window !== "undefined" && window.__CHAMPIONSHIP_SPOKE_DATA__?.blueprint?.total_champions
    ? window.__CHAMPIONSHIP_SPOKE_DATA__
    : typeof window !== "undefined" && window.__REPORT_DATA__?.blueprint?.total_champions
    ? window.__REPORT_DATA__
    : null;

  const [data, setData] = useState(preloaded?.blueprint || null);
  const [deep, setDeep] = useState(preloaded?.deep || null);
  const [indexData, setIndexData] = useState(preloaded?.index || null);
  const [loading, setLoading] = useState(!preloaded);

  useEffect(() => {
    if (preloaded) return;
    (async () => {
      try {
        const [r1, r2, r3] = await Promise.all([
          axios.get(`${API}/championship/blueprint`),
          axios.get(`${API}/championship/deep-analysis`),
          axios.get(`${API}/championship/index`),
        ]);
        setData(r1.data);
        setDeep(r2.data);
        setIndexData(r3.data);
      } catch (e) { console.error(e); }
      setLoading(false);
    })();
  }, [preloaded]);

  const all = deep?.segments?.all || {};
  const sf = deep?.segments?.sf || {};
  const oneqb = deep?.segments?.oneqb || {};
  const total = data?.total_champions || 0;
  const topPlayers = data?.top_players_on_rosters || [];
  const topStarters = data?.top_starters || [];
  
  // Merge position_ages from index data into deep segments for Age of Champion page
  const deepWithPositionAges = deep ? {
    ...deep,
    segments: {
      ...deep.segments,
      all: { ...all, position_ages: indexData?.position_ages || {} },
    }
  } : null;

  return { data, deep: deepWithPositionAges, all, sf, oneqb, total, topPlayers, topStarters, indexData, loading };
}
